import { Component, lazy, Suspense } from "react";
import { useNearViewport } from "../../hooks/useNearViewport";

const FeedbackForm = lazy(() => import("./feedback-form"));
const placeholder = <div style={{ minHeight: 270 }} aria-busy="true" />;

class FormBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed) {
      return <div style={{ minHeight: 270, color: "white" }}>
        <p>Не удалось загрузить форму.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Перезагрузить страницу
        </button>
      </div>;
    }
    return this.props.children;
  }
}

export default function LazyFeedbackForm({ defer = false, ...props }) {
  const [ref, isNear] = useNearViewport();
  return (
    <div ref={ref} style={{ width: "100%", maxWidth: "var(--feedback-form-max-width, 100%)" }}>
      {(!defer || isNear)
        ? <FormBoundary><Suspense fallback={placeholder}><FeedbackForm {...props} /></Suspense></FormBoundary>
        : placeholder}
    </div>
  );
}
